import React from 'react';

import { useAuth } from '@/src/app/context/useAuth';
import { ReportsIcon, SimpleButton } from '@/src/ui';
// TODO: Replace with SVG icons. Don't use fa
import { FaUser, FaIdBadge, FaUserShield } from 'react-icons/fa';
import IconLegend from './IconLegend';

const SuperAdminDashboard: React.FC = () => {
    document.title = 'Dashboard';
    const { user } = useAuth();

    return (
        <>
            <h1 className="page-header">Super Admin Dashboard</h1>

            <div className="my-6" />

            <div className="flex justify-center">
                <div className="bg-gray-100 rounded-xl shadow-md p-6 max-w-sm w-full">
                    {/* Card header */}
                    <div className="flex items-center gap-4 mb-4">
                        <FaUser size={36} className="text-[var(--pm-primary)]" />
                        <h2 className="text-xl font-semibold">{user?.name}</h2>
                    </div>

                    {/* Card info */}
                    <div className="space-y-2 text-sm text-gray-700">
                        <div className="flex items-center gap-2">
                            <FaIdBadge className="text-[var(--pm-primary)]" />
                            <span>Id: {user?.id}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaUser className="text-[var(--pm-primary)]" />
                            <span>Username: {user?.username}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <FaUserShield className="text-[var(--pm-primary)]" />
                            <span>Role: {user?.role}</span>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />

            <div className="flex justify-center">
                <SimpleButton className="feedback-button" onClick={() => null} color="warning">
                    <ReportsIcon color="white" /> &nbsp;
                    <a
                        href="https://docs.google.com/forms/d/1ZmRdetimXehTQDxDzeUlfFNyf1IVGwwN_q-vWHMpdLQ/edit"
                        target="_blank"
                        style={{ color: 'white', textDecoration: 'none' }}
                    >
                        Feedback Form
                    </a>
                </SimpleButton>
            </div>

            <div style={{ marginTop: 24 }}>
                <IconLegend columns={3} size={28} />
            </div>
        </>
    );
};

export default SuperAdminDashboard;
